import script from "./integralShop.vue?vue&type=script&setup=true&lang=js"
export * from "./integralShop.vue?vue&type=script&setup=true&lang=js"

import "./integralShop.vue?vue&type=style&index=0&id=1aa6c2a8&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa6c2a8"]])

export default __exports__